import React from "react";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getCredit } from "../../features/creditReducer";
import numToFixed from "../../helper/numToFixed";
import CachedIcon from "@mui/icons-material/Cached";

const Bannerlogo = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const credit = useSelector((state) => state.credit.credit);
  const [spin, setSpin] = React.useState(false);
  React.useEffect(() => {
    dispatch(getCredit());
  }, []);

  return (
    <div className="sticky z-10 top-0 bg-gradient-to-br from-[#ffffff] to-[#ffffff] h-13 text-[#b3853e] py-0.5">
      <div className="h-full z-40 my-auto grid grid-cols-3 mx-1">
        <button className="border mx-2 md:mx-20 my-2 rounded border-[#b3853e]" onClick={() => window.location.replace(localStorage.getItem("redirect"))}>กลับไปหน้าเกมส์</button>
        <div className="w-auto">
          <img
          className="w-40 md:w-40 mx-auto mt-1"
            src="./logo.png"
            alt="logo"
            onClick={() => navigate("/dashboard")}
          />
        </div>
        <div className="text-right">
          {/* <AccountCircleRoundedIcon sx={{ fontSize: 20 }} /> */}
          <span className="text-xs font-bold">{localStorage.getItem("username")}</span>

          <div className="flex justify-end">
            <p className="text-xs font-bold">
              THB <span className="text-lg">{numToFixed(credit)}</span>
            </p>
            <button
              className={`text-yellow-500 ${spin && `animate-spin`}`}
              onClick={async () => {
                await setSpin(true);
                await dispatch(getCredit());
                await setSpin(false)
              }}
            >
              <CachedIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bannerlogo;
